/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import Request from 'generic/request/Request'

export const BENEFICIARIES_URL = '/api/beneficiary/list/'
const BENEFICIARY_URL = '/api/beneficiary/'

export function getBeneficiary (uid) {
  return Request.getRequest(BENEFICIARY_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export function postBeneficiary (beneficiary) {
  return Request.postRequest(BENEFICIARY_URL + (beneficiary.uid ? beneficiary.uid + '/' : ''), beneficiary)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Beneficiary.js